






























import { Component, Prop, Watch, Mixins } from 'vue-property-decorator';
import { Textarea, File } from '@/components/form';
import Button from '@/components/ext/Button.vue';
import { FileInputMixin } from '@/pages/profile/mixins';
import { VacancyFormData, FormWatchValue } from './types';

const getForm = () => ({
  files: { name: '' },
  text: '',
});

@Component({
  components: {
    File,
    Button,
    Textarea,
  },
})
export default class RequestForm extends Mixins(FileInputMixin) {
  @Prop({ type: Object, default: null })
  readonly errors!: any;

  resultForm: VacancyFormData = getForm();
  isDisabled: boolean = true;

  @Watch('resultForm', { deep: true })
  resultFileHandler(value: FormWatchValue) {
    if (value.text.length && value.files.name.length) {
      this.isDisabled = false;
    } else {
      this.isDisabled = true;
    }
  }

  created() {
    this.reset();
  }

  submitVacancyForm() {
    const { resultForm, isDisabled } = this;
    if (isDisabled) return;
    this.$emit('submitVacancyForm', { ...resultForm });
  }

  reset() {
    this.resultForm = getForm();
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/vacancies/form/components/requestform/RequestForm.vue